import {
  TIMER_PAGINATION_SUCCESS,
  TIMER_PAGINATION_FAILURE,
} from "../constants/timerConstants";
import generateApiClient from "../helpers/generateApiClient";
import getErrorMessage from "../helpers/getErrorMessage";

const fetchTimerPaginationSuccess = (data) => ({
  type: TIMER_PAGINATION_SUCCESS,
  data,
});
const fetchTimerPaginationFailure = (error) => ({
  type: TIMER_PAGINATION_FAILURE,
  error,
});

export function fetchTimerPagination(page, archived, searchText, currentSort, setLoading) {
  return (dispatch, getState) => {
    const client = generateApiClient(getState);
    setLoading(true);
    return client
      .get(`/api/v1/timer_pagination?page=${page}&per_page=10&archived=${archived}&search=${searchText}&sort_by=${currentSort}`)
      .then((response) => {
        dispatch(fetchTimerPaginationSuccess(response.data));
        setLoading(false);
      })
      .catch((error) => {
        dispatch(fetchTimerPaginationFailure(getErrorMessage(error)));
        setLoading(false);
      });
  };
}
